import { render } from "./QuestionCard.vue?vue&type=template&id=3d40730a&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=3d40730a&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d40730a"]])

export default __exports__